import { FlexBox, Spinner, Text } from '@dixa/lib-shared-habla';
import type { CustomCardIntegrationSanitized } from 'lib-shared-types-api';
import { useEffect, useState } from 'react';

import { integrationsApi } from 'apis/integrations';

import CustomCardsItem from '../../../../containers/sidebar/cards/customCardsItem';
import type {
  SidebarCardId,
  SidebarMode,
} from '../../conversationSidebar.types';
import { useCardVisibility } from '../../hooks/useCardVisibility';

export type CustomCardsProps = {
  isMinimized?: boolean;
  csid?: number | null;
  sidebarMode: SidebarMode;
};

const emptyArray: CustomCardIntegrationSanitized[] = [];

export const CustomCards = ({
  isMinimized = false,
  csid,
  sidebarMode,
}: CustomCardsProps): JSX.Element => {
  const [hiddenCardsSnapshot, setHiddenCardsSnapshot] = useState(
    new Set<SidebarCardId>(),
  );
  const { hiddenCards } = useCardVisibility();
  const { customCards, isFetching, isError } =
    integrationsApi.useReadCustomCardIntegrationsSanitizedQuery(undefined, {
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        customCards: data?.data.custom_cards || emptyArray,
      }),
    });

  useEffect(() => {
    if (sidebarMode === 'visibility') {
      setHiddenCardsSnapshot(hiddenCards);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebarMode]);

  if (isError) {
    return (
      <FlexBox justifyContent="center" padding="400">
        <Text.Paragraph>
          Something went wrong fetching custom cards.
        </Text.Paragraph>
      </FlexBox>
    );
  }

  return (
    <>
      {isFetching ? (
        <FlexBox justifyContent="center" padding="400">
          <Spinner />
        </FlexBox>
      ) : (
        customCards
          .filter(
            (card) => sidebarMode === 'visibility' || !hiddenCards.has(card.id),
          )
          .sort((a, b) => {
            if (sidebarMode === 'visibility') {
              return (
                Number(hiddenCardsSnapshot.has(b.id)) -
                  Number(hiddenCardsSnapshot.has(a.id)) ||
                a.title.localeCompare(b.title)
              );
            }
            return a.title.localeCompare(b.title);
          })
          .map((card) => (
            <CustomCardsItem
              key={card.id}
              card={card}
              isMinimized={isMinimized}
              csid={csid}
            />
          ))
      )}
    </>
  );
};
